/** Latest server acknowledgement, never a source of server privileges. */
export const DevTestClientState = { unlimitedAmmo: false };
